import { c as _c } from "react/compiler-runtime";
import React from 'react';
const InboxOutIcon = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M11.2929 5.70711C11.6834 6.09763 12.3166 6.09763 12.7071 5.70711C13.0976 5.31658 13.0976 4.68342 12.7071 4.29289L10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2C9.73478 2 9.48043 2.10536 9.29289 2.29289L7.29289 4.29289C6.90237 4.68342 6.90237 5.31658 7.29289 5.70711C7.68342 6.09763 8.31658 6.09763 8.70711 5.70711L9 5.41421L9 10C9 10.5523 9.44771 11 10 11C10.5523 11 11 10.5523 11 10V5.41421L11.2929 5.70711Z" fill="currentColor" />;
    t1 = <path d="M3 5C3 3.89543 3.89543 3 5 3C5.55228 3 6 3.44772 6 4C6 4.55228 5.55228 5 5 5V12H7L8 14H12L13 12H15V5C14.4477 5 14 4.55228 14 4C14 3.44772 14.4477 3 15 3C16.1046 3 17 3.89543 17 5V15C17 16.1046 16.1046 17 15 17H5C3.89543 17 3 16.1046 3 15V5Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default InboxOutIcon;